import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "@/assets/customs/custom.css"
import "@/assets/customs/new-style.css"
import '@/assets/customs/custom-timeline.css'
import '@/assets/customs/custom-breadcrumbs-pointed.css'
import '@/assets/customs/custom-approval-process.css'
import '@/assets/customs/line-item-styles.css'
import '@/assets/lens_internal/css/typography.css'
import '@/assets/lens_internal/css/styles.css'
import '@/assets/lens_internal/css/override.css'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-multiselect/dist/vue-multiselect.css'
import 'js-datepicker/dist/datepicker.min.js'
import 'js-datepicker/dist/datepicker.min.css'
import MultiselectExtended from '../src/components/layout/MultiselectExtended.vue'

import i18n from './translations/i18n.js'

const options = {
    confirmButtonText: i18n.global.t('Proceed'),
    cancelButtonText: i18n.global.t('Cancel'),
    buttonsStyling: false,
    showCloseButton: true,
    customClass: {
        container: 'lens-feedback-alert__container',
        popup: 'lens-feedback-alert',
        icon: 'lens-feedback-alert__icon',
        title: 'lens-feedback-alert__title',
        htmlContainer: 'lens-feedback-alert__content',
        actions: 'lens-feedback-alert__actions',
        confirmButton: 'lens-feedback-alert__confirm',
        cancelButton: 'lens-feedback-alert__cancel',
        denyButton: 'lens-feedback-alert__deny',
        closeButton: 'lens-feedback-alert__close',
        loader: 'lens-feedback-alert__loader'
    }
}

const preventBiddingNumberInputWheel = (event) => {
    if (!router.currentRoute.value?.path?.startsWith('/high-level-estimates')) {
        return
    }

    if (event.target?.matches?.('input[type="number"]')) {
        event.preventDefault()
    }
}

window.addEventListener('wheel', preventBiddingNumberInputWheel, { passive: false, capture: true })



createApp(App).use(i18n).use(store).use(router).use(VueSweetalert2,options).component('Multiselect', MultiselectExtended).mount('#app')
